export function downloadJSON(obj, filename='export.json'){
  const data = 'data:application/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(obj, null, 2));
  const a = document.createElement('a');
  a.setAttribute('href', data);
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function downloadCSV(rows, filename='export.csv'){
  const esc = (v)=> {
    if(v == null) return '';
    const s = String(v).replace(/"/g,'""');
    if(/[",\n]/.test(s)) return '"' + s + '"';
    return s;
  };
  const csv = rows.map(r=> r.map(esc).join(',')).join('\n');
  const data = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
  const a = document.createElement('a');
  a.setAttribute('href', data);
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  a.click();
  a.remove();
}
